import Tutorial from '../Types/ExerciseData';
import Level0 from './TutorialLevels/Level0';
import Level1 from './TutorialLevels/Level1';
import Level10 from './TutorialLevels/Level10';
import Level11 from './TutorialLevels/Level11';
import Level12 from './TutorialLevels/Level12';
import Level13 from './TutorialLevels/Level13';
import Level14 from './TutorialLevels/Level14';
import Level15 from './TutorialLevels/Level15';
import Level16 from './TutorialLevels/Level16';
import Level17 from './TutorialLevels/Level17';
import Level18 from './TutorialLevels/Level18';
import Level19 from './TutorialLevels/Level19';
import Level20 from './TutorialLevels/Level20';
import Level21 from './TutorialLevels/Level21';
import Level22 from './TutorialLevels/Level22';
import Level23 from './TutorialLevels/Level23';
import Level24 from './TutorialLevels/Level24';
import Level25 from './TutorialLevels/Level25';
import Level26 from './TutorialLevels/Level26';
import Level2 from './TutorialLevels/Level2';
import Level3 from './TutorialLevels/Level3';
import Level4 from './TutorialLevels/Level4';
import Level5 from './TutorialLevels/Level5';
import Level6 from './TutorialLevels/Level6';
import Level7 from './TutorialLevels/Level7';
import Level8 from './TutorialLevels/Level8';
import Level9 from './TutorialLevels/Level9';

const TutorialData: Tutorial[] = [
  Level0,
  Level1,
  Level2,
  Level3,
  Level4,
  Level5,
  Level6,
  Level7,
  Level8,
  Level9,
  Level10,
  Level11,
  Level12,
  Level13,
  Level14,
  Level15,
  Level16,
  Level17,
  Level18,
  Level19,
  Level20,
  Level21,
  Level22,
  Level23,
  Level24,
  Level25,
  Level26,
];

export default TutorialData;
